/* Rippl water: the approved hero water (home study v95) as one shared WebGL program, used by the home hero
   (rhm-hero.js) and the site footer (rf-footer.js, study v96). Source: theme-build/assets/rippl-water.js
   The film is graded to deep Rippl navy (BS base, HS highlights) and low rings spread from each drop
   (G gain, F ring spacing, K ring edge). Three extra uniforms are left neutral by the hero so its pixels are
   unchanged: SO maps the texture (cover crop for a raw video frame), FL is a navy floor, and A fades the water
   in from the top (alpha), which lets the footer dissolve out of the white page above it.
   Loaded by both sections, so it only defines itself once. */
(function () {
  'use strict';
  if (window.RipplWater) return;
  var VS = 'attribute vec2 p;varying vec2 v;void main(){v=vec2(p.x*.5+.5,.5-p.y*.5);gl_Position=vec4(p,0.,1.);}';
  var FS = 'precision mediump float;varying vec2 v;uniform sampler2D T;uniform vec2 R;uniform float t;uniform float G;uniform float F;uniform float K;uniform float BS;uniform float HS;uniform vec4 D[16];' +
    'uniform vec4 SO;uniform vec3 FL;uniform float A;' +
    'void main(){vec2 o=vec2(0.);float h=0.;float ar=R.x/R.y;' +
    'for(int i=0;i<16;i++){vec4 d=D[i];float a=t-d.z;if(d.w<=0.||a<0.||a>2.6)continue;' +
    'vec2 q=(v-d.xy)*vec2(ar,1.);float r=length(q);float front=a*.16;' +
    'float env=exp(-pow((r-front)*K,2.))*exp(-a*1.6)*d.w;float w=sin(r*F-a*14.);' +
    'o+=normalize(q+1e-5)*w*env*(.0035+G*.03);h+=w*env;}' +
    'vec3 c=texture2D(T,(v+o)*SO.xy+SO.zw).rgb;' +
    'float l=clamp(dot(c,vec3(.299,.587,.114))+.04,0.,1.);vec3 nv=vec3(.0392,.1176,.2471);float k=smoothstep(.3,1.,l);c=mix(nv*BS*(.72+.28*smoothstep(0.,.3,l)),vec3(.84,.89,.96),k*k*HS);c=max(c,FL);c+=h*(.035+G)*vec3(.72,.88,1.12);' +
    'gl_FragColor=vec4(c,mix(1.,smoothstep(.03,.36,v.y),A));}';
  /* The approved values (hero v95, footer v96): low ripples, rings 112 apart, edge 16, film set well back. */
  var GRADE = { G: .036, F: 112, K: 16, BS: .53, HS: .21 };
  /* create(canvas) -> { gl, U, tex } with the program bound, or null when WebGL is not there or will not compile. */
  function create(cv) {
    var gl = null;
    try { gl = cv.getContext('webgl', { premultipliedAlpha: false, antialias: false }); } catch (e) { gl = null; }
    if (!gl) return null;
    function sh(type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return s; }
    var pr = gl.createProgram(); gl.attachShader(pr, sh(gl.VERTEX_SHADER, VS)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, FS)); gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) return null;
    gl.useProgram(pr);
    var b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    var U = {};
    ['R', 't', 'D', 'G', 'F', 'K', 'BS', 'HS', 'SO', 'FL', 'A'].forEach(function (n) { U[n] = gl.getUniformLocation(pr, n); });
    /* neutral: texture as drawn, no floor, fully opaque (exactly the hero's original shader) */
    gl.uniform4f(U.SO, 1, 1, 0, 0); gl.uniform3f(U.FL, 0, 0, 0); gl.uniform1f(U.A, 0);
    var tex = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    return { gl: gl, U: U, tex: tex };
  }
  /* watch(video) -> { fresh(), poke() }: fresh() is true once for each new decoded film frame, so a draw loop
     uploads the film only when the picture has changed (about 18 to 20 a second at the slowed rates, not 60).
     requestVideoFrameCallback where the browser has it; otherwise the decoded frame count, then currentTime.
     poke() forces the next fresh() true (a new source, a resize). Apple audit round 2, C3 and C5 (10 Oct 2026). */
  function watch(v) {
    var flag = true, last = -1;
    if (v && typeof v.requestVideoFrameCallback === 'function') {
      var on = function () { flag = true; v.requestVideoFrameCallback(on); };
      v.requestVideoFrameCallback(on);
      return { fresh: function () { var f = flag; flag = false; return f; }, poke: function () { flag = true; } };
    }
    return {
      fresh: function () {
        var q = 0; try { q = v.getVideoPlaybackQuality ? v.getVideoPlaybackQuality().totalVideoFrames : 0; } catch (e) { q = 0; }
        var k = q || v.currentTime;
        if (flag || k !== last) { flag = false; last = k; return true; }
        return false;
      },
      poke: function () { flag = true; }
    };
  }
  window.RipplWater = { create: create, watch: watch, GRADE: GRADE, VS: VS, FS: FS };
})();
